import { GET_CMS_AUTO_V4, GET_CMS_CANONI_V4 } from '../../constants/ActionTypes'
import { fetchData } from '../Buy'

export const getCmsAutoV4 = idAuto =>
  fetchData(GET_CMS_AUTO_V4)({
    method: 'POST',
    uri: `${window.brumbrum.url_api}/cms/p/v4/auto/${idAuto}`,
    callback: GET_CMS_AUTO_V4,
    errorMessage: GET_CMS_AUTO_V4,
  })

export const getCmsCanoniV4 = (dispatch, getState) =>
  dispatch(
    fetchData(GET_CMS_CANONI_V4)({
      method: 'POST',
      uri: `${window.brumbrum.url_api}/cms/p/v4/auto/${
        getState().product.id_auto
      }/canoni/nlt`,
      callback: GET_CMS_CANONI_V4,
      errorMessage: GET_CMS_CANONI_V4,
    })
  )
